import api from '../utilities/api';
import { isTransientFailure } from '../utilities/apiFailures';
import Users from '../schemas/public/Users';

/**
 * `null` = pas d'utilisateur pour ce jeton (réponse explicite, 4xx) : la session est à fermer.
 * Lève sur un échec transitoire (réseau, 5xx, 429) : rien à conclure, la session est gardée.
 */
export const getUser = async (): Promise<Users | null> => {
    try {
        const response = await api.get('/user?include=establishment');
        return response.data as Users;
    } catch (error) {
        if (isTransientFailure(error)) throw error;
        return null;
    }
};

export const saveUser = async (user: Users): Promise<Users | null> => {
    const userData = {
        user: {
            firstName: user.firstName,
            lastName: user.lastName,
            dob: user.dob,
            gender: user.gender,
            profilePicture: user.profilePicture,
            relationship: user.relationship,
            profession: user.profession
        }
    };
    try {
        const response = await api.post('/user/', userData);
        return response.data as Users;
    } catch {
        return null;
    }
};

export const getFamilyMembers = async (): Promise<Users[]> => {
    try {
        const response = await api.get('/family/');
        return response.data as Users[];
    } catch {
        return [];
    }
};

export const getBeneficiaryMembers = async (): Promise<Users[]> => {
    try {
        const response = await api.get('/user/beneficiary-into-family');
        return response.data as Users[];
    } catch {
        return [];
    }
};

export const checkEmail = async (email: string): Promise<boolean> => {
    try {
        const response = await api.get(`/if-user-exist?email=${email}`);
        return response.data as boolean;
    } catch {
        return false;
    }
};

export const deleteUser = async (): Promise<boolean> => {
    try {
        const response = await api.get('/user/delete-user');
        return response.data as boolean;
    } catch {
        return false;
    }
};

export const getUserById = async (id: string): Promise<Users | null> => {
    try {
        const response = await api.get(`/user/${id}`);
        return response.data[0] as Users;
    } catch {
        return null;
    }
};
